export const EDITOR_TPA_TYPE = 'Chat';

export const EDITOR_EVENT_TYPE = {
  SETTINGS_PANEL_CLOSED: 'OB_SETTINGS_CLOSED',
};
